'use client';
import _styled from '@emotion/styled/base';
import { keyframes, jsx } from '@emotion/react';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;
var VideoLive = function VideoLive(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? 'Live' : _ref$label;
  return jsx(LiveContainer, {
    className: "cue-video-ui-ctrl-live"
  }, jsx("span", {
    className: "cue-video-ui-ctrl-live-dot"
  }), label);
};
var blink = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral([" \n  0%, 100% { \n    opacity: 0; \n  }\n  50% { opacity: 1; }\n"])));
var LiveContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1eh1yce0"
} : {
  target: "e1eh1yce0",
  label: "LiveContainer"
})("display:flex;align-items:center;padding:16px;.cue-video-ui-ctrl-live-dot{display:inline-block;width:10px;height:10px;border-radius:9999px;background:red;margin-right:4px;animation:", blink, " 2s infinite;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZpZGVvLWxpdmUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTZCZ0MiLCJmaWxlIjoidmlkZW8tbGl2ZS50c3giLCJzb3VyY2VzQ29udGVudCI6WyJcbmltcG9ydCB7IFN0eWxlZENvbXBvbmVudCB9IGZyb20gJ0BjdWUvdGhlbWUnO1xuaW1wb3J0IHsgQ1NTT2JqZWN0LCBrZXlmcmFtZXMgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5cbmV4cG9ydCBjb25zdCBWaWRlb0xpdmU6IFJlYWN0LkZDPFZpZGVvTGl2ZVByb3BzICYgU3R5bGVkQ29tcG9uZW50PFZpZGVvTGl2ZUNTU092ZXJyaWRlPj4gPSAoe1xuICBsYWJlbCA9ICdMaXZlJyxcbn0pID0+IHtcbiAgcmV0dXJuIChcbiAgICA8TGl2ZUNvbnRhaW5lciBjbGFzc05hbWU9XCJjdWUtdmlkZW8tdWktY3RybC1saXZlXCI+XG4gICAgICA8c3BhbiBjbGFzc05hbWU9XCJjdWUtdmlkZW8tdWktY3RybC1saXZlLWRvdFwiPjwvc3Bhbj5cbiAgICAgIHtsYWJlbH1cbiAgICA8L0xpdmVDb250YWluZXI+XG4gICk7XG59O1xuZXhwb3J0IHR5cGUgVmlkZW9MaXZlQ1NTT3ZlcnJpZGUgPSB7XG4gICcuY3VlLXZpZGVvLXVpLWN0cmwtbGl2ZSc/OiBDU1NPYmplY3Q7XG4gICcuY3VlLXZpZGVvLXVpLWN0cmwtbGl2ZS1kb3QnPzogQ1NTT2JqZWN0O1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBWaWRlb0xpdmVQcm9wcyB7XG4gIGxhYmVsPzogc3RyaW5nO1xufVxuY29uc3QgYmxpbmsgPSBrZXlmcmFtZXNgIFxuICAwJSwgMTAwJSB7IFxuICAgIG9wYWNpdHk6IDA7IFxuICB9XG4gIDUwJSB7IG9wYWNpdHk6IDE7IH1cbmA7XG5jb25zdCBMaXZlQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgcGFkZGluZzogMTZweDtcbiAgLmN1ZS12aWRlby11aS1jdHJsLWxpdmUtZG90IHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgd2lkdGg6IDEwcHg7XG4gICAgaGVpZ2h0OiAxMHB4O1xuICAgIGJvcmRlci1yYWRpdXM6IDk5OTlweDtcbiAgICBiYWNrZ3JvdW5kOiByZWQ7XG4gICAgbWFyZ2luLXJpZ2h0OiA0cHg7XG4gICAgYW5pbWF0aW9uOiAke2JsaW5rfSAycyBpbmZpbml0ZTtcbiAgfVxuYDtcbiJdfQ== */"));

export { VideoLive };
